import React, { useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import { FaEdit, FaTrash } from "react-icons/fa";

import { OthersAction } from "../../store/actions";

import {
  tables,
  Buttons,
  inputFields,
  Spacer,
  upload,
  popover,
} from "../../components";

const VisaInfoList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { visaInfo, isVisaLoading } = useSelector((state) => state?.others);

  const [searchQuery, setSearchQuery] = useState("");

  const filteredVisaInfo = useMemo(() => {
    if (!searchQuery) return visaInfo;
    const lowerCaseQuery = searchQuery.toLowerCase();
    return visaInfo.filter((visa) =>
      visa.name.toLowerCase().includes(lowerCaseQuery)
    );
  }, [visaInfo, searchQuery]);

  const handleRemove = (id) => {
    console.log(id);
    dispatch(
      OthersAction.deleteVisaInfo({ id }, (res) => {
        dispatch(OthersAction.getVisaInfo());
      })
    );
  };

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      width: 60,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Country",
      dataIndex: "country",
      width: 300,
      render: (text, record) => record?.name,
    },

    {
      title: "Country Picture",
      dataIndex: "countryPicture",
      width: 200,
      render: (text, record) => (
        <img src={record?.visaInfos?.countryPicture} className="h-10 w-max" />
      ),
    },
    {
      title: "Cost of Application",
      dataIndex: "appCost",
      width: 300,
      render: (text, record) => record?.visaInfos?.costOfVisaApp ?? "NA",
    },
    {
      title: "Medical Fees",
      dataIndex: "medicalFees",
      width: 300,
      render: (text, record) => record?.visaInfos?.medicalFees ?? "NA",
    },
    {
      title: "Visa Duration",
      dataIndex: "visaDuration",
      width: 300,
      render: (text, record) => record?.visaInfos?.visaDuration ?? "NA",
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 100,
      fixed: "right",
      render: (text, record) => (
        <div className="flex gap-2">
          <Link
            to={`/visa-information/edit-visa-info/${record.id}`}
            className="w-full flex justify-center items-center gap-2"
            onClick={(e) => e.stopPropagation()}
          >
            <FaEdit className="text-3xl text-yellow-400" />
          </Link>
          <popover.DefaultPopconfirm
            title="Delete Visa Information?"
            description={
              <span>
                Are you sure you want to remove
                <br />
                this visa information?
              </span>
            }
            onConfirm={(e) => {
              e.stopPropagation();
              handleRemove(record?.visaInfos?.id);
            }}
            okText="Yes"
            cancelText="No"
            placement="left"
          >
            <FaTrash
              className="text-3xl text-red-600"
              onClick={(e) => {
                e.stopPropagation();
              }}
            />
          </popover.DefaultPopconfirm>
        </div>
      ),
    },
  ];

  return (
    <div className="text-black">
      <div className="flex justify-between gap-3">
        <inputFields.DefaultSearchBox
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search country..."
        />
        <div className="w-[10.5em]">
          <Buttons.DefaultButton
            onClick={() => navigate("/visa-information/add")}
            size="medium"
            width="max"
          >
            Add Visa Info
          </Buttons.DefaultButton>
        </div>
        <upload.UploadVisaInfo />
      </div>
      <Spacer height={20} />
      <div className="w-[calc(100vw-20em)] overflow-x-auto max-w-full relative">
        <tables.DefaultTable
          dataSource={filteredVisaInfo}
          columns={columns}
          rowKey={(record, index) => index}
          pagination={false}
          loading={isVisaLoading}
          onRow={(record, index) => ({
            onClick: (event) => {
              if (event.ctrlKey) {
                window.open(`/visa-information/${record.id}`, "_blank");
              } else {
                navigate(`/visa-information/${record.id}`);
              }
            },
          })}
        />
      </div>
    </div>
  );
};

export default VisaInfoList;
